document.addEventListener('DOMContentLoaded', () => {
  // NB: menu mobile e carrello stanno nel blocco in fondo a questo file.

  // Offer selection (radio cards)
  const offers = document.querySelectorAll('.offer');

  // The browser restores radio state on reload/back but not the CSS class,
  // so the highlighted card could disagree with what actually gets added.
  const syncOffers = () => {
    offers.forEach((o) => {
      const input = o.querySelector('input[type="radio"]');
      o.classList.toggle('is-selected', Boolean(input && input.checked));
    });
  };

  offers.forEach((offer) => {
    offer.addEventListener('click', () => {
      const input = offer.querySelector('input[type="radio"]');
      if (input) input.checked = true;
      syncOffers();
    });
  });

  // Su Shopify prezzo e titolo di ogni taglia stanno sulla variante: li leggo
  // dagli attributi data- del radio selezionato, cosi la barra fissa non puo'
  // dire un prezzo diverso da quello che va in cassa.
  const syncCartQty = () => {
    const checked = document.querySelector('.offer input[type="radio"]:checked');
    if (!checked) return;
    const opt = document.getElementById('stickyOpt');
    const now = document.getElementById('stickyNow');
    const was = document.getElementById('stickyWas');
    if (opt) opt.textContent = checked.dataset.variantTitle || '';
    if (now) now.textContent = checked.dataset.variantPrice || '';
    if (was) {
      const pieno = (checked.dataset.variantCompare || '').trim();
      was.textContent = pieno;
      was.hidden = !pieno;
    }
  };
  offers.forEach((o) => o.addEventListener('click', syncCartQty));

  syncOffers();
  syncCartQty();
  window.addEventListener('pageshow', () => { syncOffers(); syncCartQty(); });

  // Scroll reveal on below-the-fold section headings only — never the buy box
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    const targets = document.querySelectorAll(
      '.howto .section-title, .howto .section-sub, .ingredients .section-title, ' +
      '.timeline .section-title, .timeline .section-sub, ' +
      '.rv .section-title, .rv .section-sub, ' +
      '.clinic-copy h2, .compare .section-title, .compare .section-sub, ' +
      '.faq .section-title, .guarantee-copy h2, .reviews-heading, .circle-title'
    );
    const revealObserver = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });

    targets.forEach((el) => {
      el.classList.add('reveal');
      revealObserver.observe(el);
    });
  }

  // Review count-up: HTML already holds the real number, JS only animates toward it
  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    const countObserver = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = Number(el.dataset.target);
        const step = Math.max(1, Math.round(target / 45));
        let current = 0;
        const tick = setInterval(() => {
          current += step;
          if (current >= target) {
            current = target;
            clearInterval(tick);
          }
          el.textContent = current;
        }, 18);
        obs.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px' });

    document.querySelectorAll('.count-up').forEach((el) => {
      el.textContent = '0';
      countObserver.observe(el);
    });
  }

  // Review histogram: HTML keeps the real widths, JS zeroes them then animates back
  const histogram = document.getElementById('histogram');
  if (histogram && !prefersReducedMotion && 'IntersectionObserver' in window) {
    const fills = [...histogram.querySelectorAll('.hist-fill')];
    fills.forEach((f) => { f.style.transition = 'none'; f.style.width = '0'; });
    void histogram.offsetWidth; // reflow instead of rAF, which is frozen in hidden tabs

    new IntersectionObserver(([entry], obs) => {
      if (!entry.isIntersecting) return;
      fills.forEach((f) => { f.style.transition = ''; f.style.width = f.dataset.w; });
      obs.disconnect();
    }, { threshold: 0.4 }).observe(histogram);
  }

  // Ingredients scroller: progress bar signals there is more content sideways
  const ingScroller = document.querySelector('.ingredients-scroll');
  const ingProgress = document.getElementById('ingProgress');
  if (ingScroller && ingProgress) {
    const bar = ingProgress.querySelector('i');
    const updateProgress = () => {
      const max = ingScroller.scrollWidth - ingScroller.clientWidth;
      if (max <= 1) { ingProgress.style.display = 'none'; return; }
      ingProgress.style.display = '';
      const ratio = ingScroller.scrollLeft / max;
      const thumb = 25;
      bar.style.width = thumb + '%';
      bar.style.transform = `translateX(${ratio * (100 / thumb - 1) * 100}%)`;
    };
    ingScroller.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
  }

  // "Come Funziona" carousel: one step at a time below 769px
  const track = document.getElementById('stepsTrack');
  const prevBtn = document.querySelector('.nav-button.prev');
  const nextBtn = document.querySelector('.nav-button.next');
  if (track && prevBtn && nextBtn) {
    const slideCount = track.children.length;
    let index = 0;

    const render = () => {
      track.style.transform = `translateX(-${index * 100}%)`;
      prevBtn.disabled = index === 0;
      nextBtn.disabled = index === slideCount - 1;
    };

    prevBtn.addEventListener('click', () => {
      if (index > 0) { index -= 1; render(); }
    });
    nextBtn.addEventListener('click', () => {
      if (index < slideCount - 1) { index += 1; render(); }
    });

    // Swipe/drag — only where the carousel is active, and only for clearly
    // horizontal gestures so vertical page scrolling is never hijacked
    let startX = 0, startY = 0, dx = 0, dragging = false, axisLocked = null;

    const onDown = (e) => {
      if (window.innerWidth >= 769) return;
      dragging = true; axisLocked = null; dx = 0;
      startX = e.clientX; startY = e.clientY;
      track.style.transition = 'none';
    };

    const onMove = (e) => {
      if (!dragging) return;
      const moveX = e.clientX - startX;
      const moveY = e.clientY - startY;
      if (axisLocked === null) {
        if (Math.abs(moveX) < 6 && Math.abs(moveY) < 6) return;
        axisLocked = Math.abs(moveX) > Math.abs(moveY) ? 'x' : 'y';
      }
      if (axisLocked !== 'x') return;
      dx = moveX;
      track.style.transform = `translateX(calc(-${index * 100}% + ${dx}px))`;
    };

    const onUp = () => {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      if (axisLocked === 'x' && Math.abs(dx) > track.offsetWidth * 0.18) {
        if (dx < 0 && index < slideCount - 1) index += 1;
        else if (dx > 0 && index > 0) index -= 1;
      }
      render();
    };

    track.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
    track.style.touchAction = 'pan-y';

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 769) {
        index = 0;
        track.style.transform = '';
        prevBtn.disabled = true;
        nextBtn.disabled = false;
      } else {
        render();
      }
    });

    render();
  }

  // Sticky cart bar: appears once the main Add-to-cart button scrolls out of view
  const stickyCart = document.getElementById('stickyCart');
  const mainCartBtn = document.querySelector('.buybox .add-to-cart');
  if (stickyCart && mainCartBtn) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyCart.classList.toggle('is-visible', passed);
        stickyCart.setAttribute('aria-hidden', String(!passed));
      },
      { threshold: 0 }
    );
    observer.observe(mainCartBtn);
  }

  // Galleria: la miniatura cambia l'immagine grande, le frecce scorrono in circolo
  // I due badge erano stampati dentro la foto: non si potevano riscrivere e a
  // dimensione miniatura erano poltiglia grigia. Ora sono HTML sopra l'immagine,
  // e si vedono solo sulla prima: sulle altre (prima/dopo, infografica) stonerebbero.
  const galBadges = document.querySelector('.gal-badges');
  const syncGalBadges = (i) => { if (galBadges) galBadges.hidden = i !== 0; };
  const thumbs = [...document.querySelectorAll('.gallery-thumbs .thumb')];
  const mainImg = document.getElementById('galleryMain');
  const showThumb = (i) => {
    const t = thumbs[i];
    if (!t || !mainImg) return;
    thumbs.forEach((x) => x.classList.remove('is-active'));
    t.classList.add('is-active');
    mainImg.src = t.dataset.full;
    mainImg.alt = t.getAttribute('aria-label') || '';
    syncGalBadges(i);
    keepThumbVisible(t);
  };
  // Da telefono le miniature sono una striscia che scorre: con dieci foto, chi usa
  // le frecce arriva a immagini la cui miniatura e' fuori schermo e sembra che la
  // striscia non segua. Sposto solo il contenitore, mai la pagina.
  const strip = document.querySelector('.gallery-thumbs');
  const keepThumbVisible = (t) => {
    if (!strip || strip.scrollWidth <= strip.clientWidth) return;
    // assegnazione diretta e non scrollTo({behavior:'smooth'}): con lo scroll-snap
    // attivo su questa striscia l'animazione viene ignorata e la miniatura resta
    // fuori schermo. Lo snap da' comunque una posizione pulita.
    strip.scrollLeft = Math.max(0, t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2);
  };
  thumbs.forEach((t, i) => t.addEventListener('click', () => showThumb(i)));
  syncGalBadges(0);
  const curIdx = () => {
    const i = thumbs.findIndex((t) => t.classList.contains('is-active'));
    return i < 0 ? 0 : i;
  };
  const prev = document.querySelector('.gallery-nav.prev');
  const next = document.querySelector('.gallery-nav.next');
  if (prev) prev.addEventListener('click', () => showThumb((curIdx() - 1 + thumbs.length) % thumbs.length));
  if (next) next.addEventListener('click', () => showThumb((curIdx() + 1) % thumbs.length));

  // Ingrandimento galleria: tocchi la foto e si apre a schermo pieno.
  // E' il gesto che tutti si aspettano su mobile, e senza non si vedono
  // i dettagli del prima/dopo.
  if (mainImg) {
    const lb = document.createElement('div');
    lb.className = 'lightbox';
    lb.setAttribute('aria-hidden', 'true');
    lb.innerHTML =
      '<button class="lb-close" type="button" aria-label="Chiudi">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
      '</button>' +
      '<button class="lb-nav lb-prev" type="button" aria-label="Immagine precedente">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
      '</button>' +
      '<img class="lb-img" alt="">' +
      '<button class="lb-nav lb-next" type="button" aria-label="Immagine successiva">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>' +
      '</button>' +
      '<span class="lb-count"></span>';
    document.body.appendChild(lb);

    const lbImg = lb.querySelector('.lb-img');
    const lbCount = lb.querySelector('.lb-count');
    let lastFocus = null;

    const paint = () => {
      const t = thumbs[curIdx()];
      if (!t) return;
      lbImg.src = t.dataset.full;
      lbImg.alt = t.getAttribute('aria-label') || '';
      lbCount.textContent = (curIdx() + 1) + ' / ' + thumbs.length;
    };
    const open = () => {
      lastFocus = document.activeElement;
      paint();
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      lb.querySelector('.lb-close').focus();
    };
    const close = () => {
      lb.classList.remove('is-open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    };
    const step = (d) => {
      showThumb((curIdx() + d + thumbs.length) % thumbs.length);
      paint();
    };

    // Scorrimento col dito sulla foto grande. Finora si poteva cambiare immagine
    // solo con le frecce o le miniature: per questo le frecce erano grosse. Con
    // lo swipe le frecce tornano a essere una seconda strada e possono rimpicciolirsi.
    let swipeX = null, swipeY = null, asseGal = null, haScorso = false;
    mainImg.addEventListener('touchstart', (e) => {
      swipeX = e.touches[0].clientX; swipeY = e.touches[0].clientY;
      asseGal = null; haScorso = false;
    }, { passive: true });
    mainImg.addEventListener('touchmove', (e) => {
      if (swipeX === null) return;
      const dx = e.touches[0].clientX - swipeX, dy = e.touches[0].clientY - swipeY;
      if (!asseGal && Math.abs(dx) + Math.abs(dy) > 8) {
        asseGal = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
    }, { passive: true });
    mainImg.addEventListener('touchend', (e) => {
      if (swipeX === null) { return; }
      const dx = e.changedTouches[0].clientX - swipeX;
      if (asseGal === 'x' && Math.abs(dx) > 45) {
        haScorso = true;   // cosi il tocco non apre anche lo zoom
        showThumb((curIdx() + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length);
      }
      swipeX = null;
    });

    mainImg.addEventListener('click', () => { if (!haScorso) open(); });
    mainImg.style.cursor = 'zoom-in';
    lb.querySelector('.lb-close').addEventListener('click', close);
    lb.querySelector('.lb-prev').addEventListener('click', () => step(-1));
    lb.querySelector('.lb-next').addEventListener('click', () => step(1));
    // il click sullo sfondo chiude, quello sulla foto no
    lb.addEventListener('click', (e) => { if (e.target === lb) close(); });
    document.addEventListener('keydown', (e) => {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });
    // swipe orizzontale, con blocco d'asse per non rubare lo scroll verticale
    let x0 = null, y0 = null, asse = null;
    lbImg.addEventListener('touchstart', (e) => {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; asse = null;
    }, { passive: true });
    lbImg.addEventListener('touchmove', (e) => {
      if (x0 === null) return;
      const dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
      if (!asse && Math.abs(dx) + Math.abs(dy) > 8) asse = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
    }, { passive: true });
    lbImg.addEventListener('touchend', (e) => {
      if (x0 === null || asse !== 'x') { x0 = null; return; }
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) step(dx < 0 ? 1 : -1);
      x0 = null;
    });
  }
});

/* =========================================================================
   Video "Guardalo in azione": la miniatura apre il filmato a pieno schermo.
   I file non vengono scaricati finche non si tocca (preload="none"):
   sono circa 4 MB l'uno e quasi tutti i clienti navigano da telefono.
   ========================================================================= */
document.addEventListener('DOMContentLoaded', () => {
  const tiles = [...document.querySelectorAll('.video-item[data-video]')];
  if (!tiles.length) return;

  const box = document.createElement('div');
  box.className = 'vbox';
  box.setAttribute('role', 'dialog');
  box.setAttribute('aria-modal', 'true');
  box.setAttribute('aria-label', 'Video');
  box.innerHTML =
    '<button class="vbox-close" type="button" aria-label="Chiudi video">' +
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
    '</button>' +
    '<video playsinline controls preload="none"></video>';
  document.body.appendChild(box);

  const video = box.querySelector('video');
  const closeBtn = box.querySelector('.vbox-close');
  let tornaA = null;

  const open = (src, poster, from) => {
    tornaA = from;
    video.src = src;
    video.poster = poster || '';
    box.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
    video.play().catch(() => { /* se il browser blocca, restano i controlli */ });
  };

  const close = () => {
    video.pause();
    box.classList.remove('is-open');
    document.body.style.overflow = '';
    // libera la rete: senza questo il file continua a scaricarsi
    video.removeAttribute('src');
    video.load();
    if (tornaA) tornaA.focus();
  };

  tiles.forEach((t) => {
    t.addEventListener('click', () => {
      const img = t.querySelector('img');
      open(t.dataset.video, img ? img.getAttribute('src') : '', t);
    });
  });

  closeBtn.addEventListener('click', close);
  box.addEventListener('click', (e) => { if (e.target === box) close(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && box.classList.contains('is-open')) close();
  });
});

/* =========================================================================
   Carrello Shopify + menu mobile.
   Sostituisce shared.js: qui il carrello e quello vero di Shopify
   (Cart AJAX API), non piu uno finto in localStorage.
   ========================================================================= */
document.addEventListener('DOMContentLoaded', () => {
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------- menu mobile ---------- */
  const burger = $('.hamburger');
  const menu = $('#mobileMenu');
  if (burger && menu) {
    const setMenu = (open) => {
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', String(!open));
      burger.setAttribute('aria-expanded', String(open));
      burger.classList.toggle('is-open', open);
      document.body.classList.toggle('no-scroll', open);
    };
    burger.addEventListener('click', () => setMenu(!menu.classList.contains('is-open')));
    menu.addEventListener('click', (e) => { if (e.target === menu) setMenu(false); });
    $$('.mm-list a', menu).forEach((a) => a.addEventListener('click', () => setMenu(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setMenu(false); });
  }

  /* ---------- pannello carrello ---------- */
  const cart = $('#cart');
  const openCart = () => {
    if (!cart) return;
    cart.classList.add('is-open');
    cart.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  };
  const closeCart = () => {
    if (!cart) return;
    cart.classList.remove('is-open');
    cart.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  };
  $$('.cart-open').forEach((b) => b.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', closeCart));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  /* ---------- ridisegna il pannello ---------- */
  // Prima erano tre richieste in fila (aggiungi, ridisegna, conta i pezzi) e il
  // pannello partiva solo alla fine: ~740 ms da telefono. Ora Shopify manda il
  // carrello gia' disegnato dentro la stessa risposta dell'aggiunta (parametro
  // "sections"), e il numero dei pezzi sta scritto sul pannello: una richiesta sola.
  const SEZIONE = 'cart-drawer';
  const pannello = () => cart && cart.querySelector('.cart-panel');

  const applica = (html) => {
    if (!html || !cart) return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('.cart-panel');
    if (!fresh) return false;
    const p = pannello();
    p.innerHTML = fresh.innerHTML;
    p.dataset.itemCount = fresh.dataset.itemCount || '0';
    $$('[data-cart-close]', cart).forEach((b) => b.addEventListener('click', closeCart));
    bindLines();
    const n = parseInt(p.dataset.itemCount, 10) || 0;
    $$('.cart-count').forEach((c) => { c.textContent = n; c.hidden = n === 0; });
    return true;
  };

  const caricamento = (si) => { const p = pannello(); if (p) p.classList.toggle('is-loading', si); };

  // riserva: se una risposta arriva senza sezione, la chiedo a parte
  const refreshCart = async () => {
    try {
      const data = await fetch(`${window.location.pathname}?sections=${SEZIONE}`).then((r) => r.json());
      applica(data[SEZIONE]);
    } catch (e) { /* resta il pannello attuale */ }
  };

  /* ---------- aggiungi al carrello senza ricaricare ---------- */
  const form = $('[data-product-form]');
  if (form) {
    let inCorso = false;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (inCorso) return;          // doppio tocco: una sola aggiunta
      inCorso = true;
      // il pannello si apre al tocco: i 380 ms dell'animazione coprono la rete
      caricamento(true);
      openCart();
      const dati = new FormData(form);
      dati.append('sections', SEZIONE);
      dati.append('sections_url', window.location.pathname);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST', body: dati, headers: { Accept: 'application/json' },
        });
        if (!res.ok) throw new Error('add failed');
        const json = await res.json();
        if (!applica(json.sections && json.sections[SEZIONE])) await refreshCart();
      } catch (err) {
        closeCart();
        form.submit(); // rete assente o errore: invio normale, il cliente non resta bloccato
        return;
      } finally {
        caricamento(false);
        inCorso = false;
      }
    });
  }

  /* ---------- piu / meno sulle righe del carrello ---------- */
  /* ---------- editor del tema ---------- */
  // Shopify reinietta la sezione a ogni modifica: l'osservatore delle animazioni
  // e' gia' passato, quindi senza questo la sezione resta invisibile.
  const mostraSubito = (root) => {
    (root || document).querySelectorAll('.reveal').forEach((e) => e.classList.add('is-visible'));
  };
  if (window.Shopify && window.Shopify.designMode) {
    mostraSubito(document);
    document.addEventListener('shopify:section:load', (e) => mostraSubito(e.target));
    document.addEventListener('shopify:section:select', (e) => mostraSubito(e.target));
  }

  // Un solo cambio alla volta: un secondo tocco mentre il primo e' in viaggio
  // partirebbe dai numeri vecchi e sposterebbe l'offerta due volte.
  // Qui non si usa "caricamento": quello nasconde tutto il contenuto, e su un
  // piu' / meno faceva lampeggiare il carrello per tutto il mezzo secondo che
  // Shopify impiega a registrare il cambio. Si attenuano solo i prezzi.
  let rigaOccupata = false;
  const inviaCarrello = async (url, corpo) => {
    rigaOccupata = true;
    const p = pannello();
    if (p) p.classList.add('is-updating');
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...corpo, sections: SEZIONE, sections_url: window.location.pathname }),
      });
      const json = await res.json();
      if (!applica(json.sections && json.sections[SEZIONE])) await refreshCart();
    } catch (e) {
      await refreshCart();
    } finally {
      const q = pannello();
      if (q) q.classList.remove('is-updating');
      rigaOccupata = false;
    }
  };

  const flaconi = (n) => `45g · ${n} ${n === 1 ? 'flacone' : 'flaconi'}`;

  function bindLines() {
    // solo le righe vere: quella del regalo non ha stepper ne' numero di riga
    $$('.cart-line[data-line]', cart).forEach((riga) => {
      const line = Number(riga.dataset.line);
      const key = riga.dataset.key;
      const regalo = riga.nextElementSibling && riga.nextElementSibling.classList.contains('cart-line--gift')
        ? riga.nextElementSibling : null;
      // il numero cambia al tocco; prezzi e totale arrivano con la risposta
      const anticipa = (b) => {
        const n = Number(b.dataset.mostra) || 0;
        if (!n) return;
        const campo = riga.querySelector('[data-qty]');
        const testo = riga.querySelector('.cart-var');
        if (campo) campo.textContent = n;
        if (testo) testo.textContent = flaconi(n);
        if (!regalo) return;
        const g = Number(b.dataset.mostraRegalo) || 0;
        const gt = regalo.querySelector('.cart-var');
        if (g && gt) gt.textContent = flaconi(g);
        if (!g) regalo.classList.add('is-removing');
      };
      // lo stepper mostra i flaconi pagati: i pulsanti portano scritto cosa fare
      // (quantita' nuova, oppure passaggio all'offerta accanto), non si ricalcola qui
      riga.querySelectorAll('[data-qty-set]').forEach((b) => b.addEventListener('click', () => {
        if (rigaOccupata) return;
        anticipa(b);
        inviaCarrello('/cart/change.js', { line, quantity: Math.max(0, Number(b.dataset.qtySet) || 0) });
      }));
      riga.querySelectorAll('[data-swap-to]').forEach((b) => b.addEventListener('click', () => {
        if (rigaOccupata || !key) return;
        anticipa(b);
        inviaCarrello('/cart/update.js', {
          updates: { [key]: 0, [b.dataset.swapTo]: Number(b.dataset.swapQty) || 1 },
        });
      }));
      const via = riga.querySelector('[data-remove]');
      if (via) via.addEventListener('click', () => {
        if (rigaOccupata) return;
        riga.classList.add('is-removing');
        if (regalo) regalo.classList.add('is-removing');
        inviaCarrello('/cart/change.js', { line, quantity: 0 });
      });
    });
  }
  if (cart) bindLines();
});
